import { render, staticRenderFns } from "./ooe-with-actions.vue?vue&type=template&id=c4963a5a&"
import script from "./ooe-with-actions.vue?vue&type=script&lang=js&"
export * from "./ooe-with-actions.vue?vue&type=script&lang=js&"
import style0 from "./ooe-with-actions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports